import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Import components
import Header from "./components/Header";
import Hero from "./components/Hero";
import Features from "./components/Features";
import ProductTour from "./components/ProductTour";
import About from "./components/About";
import Testimonials from "./components/Testimonials";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions";
import DataProcessingAgreement from "./components/DataProcessingAgreement";
import SEO from "./components/SEO";
import routeMetadata from "./seoMetadata.json";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);
      if (element) {
        const headerOffset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition =
          elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    }
  }, [location]);
  return (
    <div className="min-h-screen">
      <SEO {...routeMetadata.home} />
      <Header />
      <main id="main-content">
        <Hero />
        <Features />
        <ProductTour />
        <About />
        <Testimonials />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
};
const PrivacyPolicyApp = () => {
  return (
    <div className="min-h-screen">
      <SEO {...routeMetadata.privacy} />
      <Header />
      <main id="main-content">
        <PrivacyPolicy />
      </main>
      {/* <ContactForm /> */}
      <Footer />
    </div>
  );
};
const TermsAndConditionsApp = () => {
  return (
    <div className="min-h-screen">
      <SEO {...routeMetadata.terms} />
      <Header />
      <main id="main-content">
        <TermsAndConditions />
      </main>
      {/* <ContactForm /> */}
      <Footer />
    </div>
  );
};
const DataProcessingAgreementApp = () => {
  return (
    <div className="min-h-screen">
      <SEO {...routeMetadata.dataProcessing} />
      <Header />
      <main id="main-content">
        <DataProcessingAgreement />
      </main>
      {/* <ContactForm /> */}
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* <Route path="/" element={<Home />} /> */}
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyApp />} />
          <Route path="/terms" element={<TermsAndConditionsApp />} />
          <Route path="/data-processing" element={<DataProcessingAgreementApp />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
